import React from "react";
import stilePulsanti from "../../interfaccia/stilePulsanti";


function CodiceHTML({numCamp, linkIT, linkEN, linkFR, deskMob, lang, alt}) {

    const {
        classiTastoSblocco,
        classiTastoCopia,
        tastoCopiaAspetto
    } = stilePulsanti

    let linkGiusto;

    if (lang === "IT") {
        linkGiusto = linkIT
    }

    if (lang === "EN") {
        linkGiusto = linkEN
    }

    if (lang === "FR") {
        linkGiusto = linkFR
    }

        
    const codHtml = `<p><a href="${linkGiusto}"> <img class="banner-img" src="https://www.vigliettisport.com/img/cms/SLIDER/camp${numCamp}/VS_SLIDE_${deskMob}_${lang}.jpg" alt="${alt}" /></a></p>`


    return (
        <div className="flex items-center anteprimaHTML">
            <button onClick={(e) => navigator.clipboard.writeText(codHtml).then(e.preventDefault())} className={classiTastoCopia}>{tastoCopiaAspetto}</button>
            <h3 className="ml3 w-10">{lang}</h3>
            <pre className="w-80 sfondoBiancoTema">
                {codHtml}
            </pre>
            
        </div>
    )
}

export default CodiceHTML;



